<template>
	<v-container fluid class="ma-0 pa-0">
		<v-col class="ma-0 pa-0" cols="12" id="head_title">
			<v-col class="pa-0" cols="12" id="main_content_maxwidthset">
				<v-row class="ma-0 pa-0" align="center" justify="space-between" id="header_height">
					<v-col class="ma-0 pa-0" cols="auto">{{ts('title')}}</v-col>
					<v-row class="ma-0 pa-0" align="center" justify="end">
						<!-- <v-btn width="9rem" height="auto" @click="requestReset"
							class="ma-0 pa-2" id="grey_btn" elevation="0">
								{{ t('reset') }}
						</v-btn> -->
						<v-btn width="9rem" height="auto" @click="requestSave"
							class="ma-0 pa-2 ml-2" id="blue_btn" elevation="0">
								{{ ts('save') }}
						</v-btn>
					</v-row>
				</v-row>
			</v-col>
		</v-col>
    <v-col class="pa-0" id="main_content_maxwidthset" cols="12" align="center">
			<v-col class="ma-0 pa-0 pt-9" cols="10">
				<!-- 모점 사용자 권한 설정 -->
				<v-col id="setting_btn1" class="ma-0 pa-0 setting_btn" cols="12"
					v-if="authorities.SET_PERMISSIONS_GROUP">
					<v-btn id="back_clean_btn1" width="100%" height="auto"
						class="ma-0 pa-0 back_clean_btn" elevation="0" @click="goAuthoritySetting">
						<v-row class="ma-0 pa-4" align="center" justify="space-between">
							<v-col class="ma-0 pa-0" cols="auto">{{ts('shareUserPermissionSettings')}}</v-col>
							<v-row class="ma-0 pa-0" align="center" justify="end">
								<v-col class="ma-0 pa-0 pr-3" cols="auto"
									v-if="role == 'main' || role == 'head'">{{ts('shareUserOfTheMainStore')}}</v-col>
                <v-col class="ma-0 pa-0" cols="auto">
								  <v-img height="1rem" width="0.6rem" class="ma-0 pa-0 ml-2 pr-2"
									  src="@/assets/images/right_btn.png"></v-img>
                </v-col>
							</v-row>
						</v-row>
					</v-btn>
				</v-col>
				<!-- 지점 검색 및 사용자 권한 설정 -->
				<!-- <v-col id="setting_btn2" class="ma-0 pa-0 setting_btn" cols="12"
					v-if="role == 'main' || role == 'head' && authorities.SET_BRANCH_USER">
					<v-btn id="back_clean_btn2" width="100%" height="auto"
						class="ma-0 pa-0 back_clean_btn" elevation="0" @click="goBranchStoreSearch">
						<v-row class="ma-0 pa-4" align="center" justify="end">
							<v-col class="ma-0 pa-0 pr-3" cols="auto">{{ts('branchShareUser')}}</v-col>
              <v-col class="ma-0 pa-0" cols="auto">
							  <v-img height="1rem" width="0.6rem" class="ma-0 pa-0 ml-2 pr-2"
							  	src="@/assets/images/right_btn.png"></v-img>
              </v-col>
						</v-row>
					</v-btn>
				</v-col> -->
				<!-- <v-col id="setting_btn3" class="ma-0 pa-0 setting_btn" cols="12">
					<v-row class="ma-0 pa-2 pl-4" align="center" justify="space-between">
						<v-col class="ma-0 pa-0" cols="auto">{{ts('twoWayCallTimeSetting')}}</v-col>
						<v-col class="ma-0 pa-0" cols="2">
							<v-select class="ma-0 pa-0" v-model="selectedTime"
								:items="timeList" dense hide-details outlined
								dark item-text="label" item-value="value"
							></v-select>
						</v-col>
					</v-row>
				</v-col> -->
				<!-- <v-col id="setting_btn4" class="ma-0 pa-0 setting_btn" cols="12"
					v-if="authorities.SET_DISCONNECTION_ALARM">
					<v-row class="ma-0 pa-2 pl-4" align="center" justify="space-between">
						<v-col class="ma-0 pa-0" cols="auto">{{ts('timeSettingForDisconnectionNotification')}}</v-col>
						<v-col class="ma-0 pa-0" cols="2">
							<v-select class="ma-0 pa-0" v-model="selectedDisconnectedTime"
								:items="notiTimeList" dense hide-details outlined
								dark item-text="label" item-value="value"
							></v-select>
						</v-col>
					</v-row>
				</v-col> -->
				<!-- 시간 경과에 따른 자동 로그아웃 설정 -->
				<v-col id="setting_btn5" class="ma-0 pa-0 setting_btn" cols="12"
					v-if="authorities.SET_LOGOUT_TIME">
					<v-row class="ma-0 pa-2 pl-4" align="center" justify="space-between">
						<v-col class="ma-0 pa-0" cols="auto">{{ts('automaticLogoutOverTime')}}</v-col>
						<v-col class="ma-0 pa-0" cols="2">
							<v-select class="ma-0 pa-0" v-model="selectedAutoLogoutTime"
								:items="autoLogoutTimeList" dense hide-details outlined
								dark item-text="label" item-value="value"
							></v-select>
						</v-col>
					</v-row>
				</v-col>
				<!-- 비활성 시 세션 시간 초과 로그아웃 설정 -->
				<v-col id="setting_btn6" class="ma-0 pa-0 setting_btn" cols="12"
					v-if="authorities.SET_LOGOUT_TIME">
					<v-row class="ma-0 pa-2 pl-4" align="center" justify="space-between">
						<v-col class="ma-0 pa-0" cols="auto">{{ts('sessionTimeoutWhenInactive')}}</v-col>
						<v-col class="ma-0 pa-0" cols="2">
							<v-select class="ma-0 pa-0" v-model="selectedInactiveTime"
								:items="sessionTimeList" dense hide-details outlined
								dark item-text="label" item-value="value"
							></v-select>
						</v-col>
					</v-row>
				</v-col>
				<!-- 알림 설정 -->
				<v-col id="setting_btn7" class="ma-0 pa-0 setting_btn" cols="12">
					<v-btn id="back_clean_btn3" width="100%" height="auto"
						class="ma-0 pa-0 back_clean_btn" elevation="0" @click="goNotificationSetting">
						<v-row class="ma-0 pa-4" align="center" justify="space-between">
							<v-col class="ma-0 pa-0" cols="auto">{{ts('notificationSetting')}}</v-col>
							<v-col class="ma-0 pa-0" cols="auto">
							  <v-img height="1rem" width="0.6rem" class="ma-0 pa-0 ml-2 pr-2"
							  	src="@/assets/images/right_btn.png"></v-img>
              </v-col>
						</v-row>
					</v-btn>
				</v-col>
				<!-- 내점 고객 분석 설정 --> 
				<v-col id="setting_btn7" class="ma-0 pa-0 setting_btn" cols="12" v-if="canAiCameraSetting"> <!-- v-if="authorities.???" 대체예정 -->
					<v-btn id="back_clean_btn3" width="100%" height="auto"
						class="ma-0 pa-0 back_clean_btn" elevation="0" @click="goInternalCustomerAnalysisSetting">
						<v-row class="ma-0 pa-4" align="center" justify="space-between">
							<v-col class="ma-0 pa-0" cols="auto">{{ts('internalCustomerAnalysisSetting')}}</v-col>
							<v-col class="ma-0 pa-0" cols="auto">
							  <v-img height="1rem" width="0.6rem" class="ma-0 pa-0 ml-2 pr-2"
							  	src="@/assets/images/right_btn.png"></v-img>
              </v-col>
						</v-row>
					</v-btn>
				</v-col>
				<!-- 점포검색시의 시구정촌 표시 여부 -->
				<v-col class="ma-0 pa-0 setting_btn" cols="12"
					v-if="role == 'main' || role == 'head'">
					<v-col cols="12" class="ma-0 pa-0 back_clean_btn">
						<v-row class="ma-0 pa-4" align="center" justify="space-between">
							<v-col class="ma-0 pa-0" cols="auto">{{ts('cityDisplayWhenSearch')}}</v-col>
							<v-col class="ma-0 pa-0" cols="auto">
							  <v-row class="ma-0 pa-0" align="center">
									<v-col class="ma-0 pa-0 mr-5" cols="auto">
										{{cityDisplayValue ? ts('enabled') : ts('invalid')}}
									</v-col>
									<v-switch class="ma-0 pa-0"
                  	v-model="cityDisplayValue" hide-details></v-switch>
								</v-row>
              </v-col>
						</v-row>
					</v-col>
				</v-col>
				<!-- <v-col id="setting_btn8" class="ma-0 pa-0 setting_btn" cols="12"
					v-if="authorities.SET_CONTRACT">
					<v-btn id="back_clean_btn4" width="100%" height="auto"
						class="ma-0 pa-0 back_clean_btn" elevation="0">
						<v-row class="ma-0 pa-4" align="center" justify="space-between">
							<v-col class="ma-0 pa-0" cols="auto">{{ts('unitChangePlanChange')}}</v-col>
							<v-img max-height="1rem" max-width="1rem" class="ma-0 pa-0 pr-2"
								src="@/assets/images/right_btn.png"></v-img>
						</v-row>
					</v-btn>
				</v-col> -->
				<!-- <v-col id="setting_btn9" class="ma-0 pa-0 setting_btn" cols="12"
					v-if="authorities.SET_CONTRACT">
					<v-btn id="back_clean_btn5" width="100%" height="auto"
						class="ma-0 pa-0 back_clean_btn" elevation="0">
						<v-row class="ma-0 pa-4" align="center" justify="space-between">
							<v-col class="ma-0 pa-0" cols="auto">{{ts('optionalFunctionSubscription')}}</v-col>
							<v-img max-height="1rem" max-width="1rem" class="ma-0 pa-0 pr-2"
								src="@/assets/images/right_btn.png"></v-img>
						</v-row>
					</v-btn>
				</v-col> -->
        <!-- Anonymous 표시 여부 -->
        <v-col class="ma-0 pa-0 setting_btn" cols="12"
               v-if="authorities.SET_STORE_CONFIG && uasCount > 0">
          <v-col cols="12" class="ma-0 pa-0 back_clean_btn">
            <v-row class="ma-0 pa-4" align="center" justify="space-between">
              <v-col class="ma-0 pa-0" cols="auto">{{ts('anonymousDisplay')}}</v-col>
              <v-col class="ma-0 pa-0" cols="auto">
                <v-row class="ma-0 pa-0" align="center">
                  <v-col class="ma-0 pa-0 mr-5" cols="auto">
                    {{anonymousDisplayEnable ? t('express') : t('nonRepresentation')}}
                  </v-col>
                  <v-switch class="ma-0 pa-0"
                            v-model="anonymousDisplayEnable" hide-details></v-switch>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
        </v-col>
				<!-- 버전 표시 -->
        <v-col id="setting_btn10" class="ma-0 pa-0 setting_btn" cols="12">
					<v-col cols="12" class="ma-0 pa-0 back_clean_btn">
						<v-row class="ma-0 pa-4" align="center" justify="space-between">
							<v-col class="ma-0 pa-0" cols="auto">{{ts('version')}}</v-col>
							<v-col class="ma-0 pa-0" cols="auto">
							  {{version}}
              </v-col>
						</v-row>
					</v-col>
				</v-col>
			</v-col>
		</v-col>
	</v-container>
</template>

<script>
import mixin from '@/mixin';
import { mapState } from 'vuex';
export default {
	components: {
		
	},
	mixins: [mixin.common],
	data: () => ({
		role: '',
		authorities: {},
		selectedTime: 60,
		selectedDisconnectedTime: 1800,
		selectedAutoLogoutTime: 14400,
		selectedInactiveTime: 3600,
		cityDisplayValue: false,
    anonymousDisplayEnable: true,
    version: "",
    uasCount: 0,
	}),
	computed: {
		...mapState('contract', ['hasUAU01B']),
		timeList() {
			return [
				{ label: '1' + this.$i18n.t('lang.common.minute'), value: 60 },
				{ label: '2' + this.$i18n.t('lang.common.minute'), value: 120 },
				{ label: '3' + this.$i18n.t('lang.common.minute'), value: 180 },
				{ label: '4' + this.$i18n.t('lang.common.minute'), value: 240 },
				{ label: '5' + this.$i18n.t('lang.common.minute'), value: 300 },
			];
		},
		notiTimeList() {
			return [
				{ label: '10' + this.$i18n.t('lang.common.minute'), value: 600 },
				{ label: '30' + this.$i18n.t('lang.common.minute'), value: 1800 },
				{ label: '1' + this.$i18n.t('lang.common.hourTime'), value: 3600 },
				{ label: '12' + this.$i18n.t('lang.common.hourTime'), value: 43200 },
				{ label: '24' + this.$i18n.t('lang.common.hourTime'), value: 86400 },
			];
		},
		autoLogoutTimeList() {
			return [
				{ label: '15' + this.$i18n.t('lang.common.minute'), value: 900 },
				{ label: '1' + this.$i18n.t('lang.common.hourTime'), value: 3600 },
				{ label: '4' + this.$i18n.t('lang.common.hourTime'), value: 14400 },
				{ label: '8' + this.$i18n.t('lang.common.hourTime'), value: 28800 },
				{ label: '12' + this.$i18n.t('lang.common.hourTime'), value: 43200 },
				{ label: '24' + this.$i18n.t('lang.common.hourTime'), value: 86400 },
			];
		},
		sessionTimeList() {
			return [
				{ label: '5' + this.$i18n.t('lang.common.minute'), value: 300 },
				{ label: '15' + this.$i18n.t('lang.common.minute'), value: 900 },
				{ label: '1' + this.$i18n.t('lang.common.hourTime'), value: 3600 },
				{ label: '4' + this.$i18n.t('lang.common.hourTime'), value: 14400 },
				{ label: '8' + this.$i18n.t('lang.common.hourTime'), value: 28800 },
				{ label: '12' + this.$i18n.t('lang.common.hourTime'), value: 43200 },
				{ label: '24' + this.$i18n.t('lang.common.hourTime'), value: 86400 },
			];
		},
    canAiCameraSetting() {
      let flag = true;
      if (!this.hasUAU01B) flag = false;
      const authorityCd = this.$store.getters.getRole;
      if (authorityCd == '12' || authorityCd == '13' || authorityCd == '22' || authorityCd == '23'
        || authorityCd == '32' || authorityCd == '33' || authorityCd == '2' || authorityCd == '3'
      ) flag = false;
      return flag; 
    }
	},
	created() {
    this.role = this.roleCheck(this.$store.getters.getRole);
		this.authorities = this.$store.getters.getAuthorities;
	},
	mounted() {
		this.userConfig = this.$store.getters.getUserConfig;
		this.selectedAutoLogoutTime = this.userConfig.autoTimeout * 60;
		this.selectedInactiveTime = this.userConfig.inactiveTimeout * 60;
		this.cityDisplayValue = this.userConfig.printCityName;
    this.anonymousDisplayEnable = this.$store.getters.getAnonymousDisplayEnable;
    this.uasCount = this.$store.getters.getUasCount;
    this.version = process.env.VUE_APP_VERSION_CODE;
	},
	methods: {
		ts(t) {
      return this.$t("lang.settings." + t);
    },
		requestReset() {
			this.$dialog.confirm({
				title: this.ts('settingReset'),
				text: this.ts('askSettingReset'),
				actions: {
					false: { color: 'white', text: this.t('cancel'),},
					true: {
						color: 'white', text: this.t('reset2'),
						handle: () => {
							this.selectedDisconnectedTime = 1800;
							this.selectedAutoLogoutTime = 14400;
							this.selectedInactiveTime = 3600;
							this.$vloading.show();
							this.requestUserConfigSave(true);
						}
					}
				}
			});
		},
		requestSave() {
			this.$dialog.confirm({
				title: this.ts('changeConfig'),
				text: this.ts('askChangeConfig'),
				actions: {
					false: { color: 'white', text: this.t('cancel'),},
					true: {
						color: 'white', text: this.ts('changeAndSave'),
						handle: () => {
							this.$vloading.show();
							this.requestUserConfigSave(false);
						}
					}
				}
			});
		},
		requestUserConfigSave(reset) {
      if(!reset) this.requestChangeAnonymousDisplayEnable();
			let params = {
				autoTimeout: reset == true ? 240 : this.selectedAutoLogoutTime / 60,
				inactiveTimeout: reset == true ? 60 : this.selectedInactiveTime / 60,
				printCityName: this.cityDisplayValue
			};
			this.networkController.updateUserConfig(params).then(async (res) => {
				console.log('%cUser Config\n', "color:#008DD0;", res.data);
				await this.$store.commit('setUserConfig', res.data);
				this.$vloading.hide();
				if(reset) {
					this.showToastMessage(this.tmb('resetSuccess'));
				} else {
					this.showToastMessage(this.tmb('saved'));
				}
			}).catch(error => {
				this.$vloading.hide();
				this.showToastMessage(this.tmb('requestFail'));
			});
		},
		goAuthoritySetting() {
			this.pushRoute('/setting/authority', {});
		},
		goBranchStoreSearch() {
			this.pushRoute('/setting/branch-search', {});
		},
    goStoreGroup() {
      this.pushRoute('/store-group/create', {});
    },
    goStoreGroupDetail() {
    	this.pushRoute('/store-group/detail?groupId=1', {});
    },
		goNotificationSetting() {
			this.pushRoute('/setting/notification', {});
		},
		goInternalCustomerAnalysisSetting() {
			this.pushRoute('/setting/analysis-device', {});
		},
    requestChangeAnonymousDisplayEnable() {
      const params = {
        anonymousViewable: this.anonymousDisplayEnable,
        unisCustomerCd: this.$store.getters.getUserunisCustomerCd
      };
      this.networkController.changeAnonymousDisplayEnable(params)
        .then(async (res) => {
          this.$store.commit('setAnonymousDisplayEnable', this.anonymousDisplayEnable);
        }).catch(error => {
        this.showToastMessage('Anonymous設定失敗');
      });
    }
	}
}
</script>

<style lang="scss" scoped>
#head_title {
	background-color: #272A33;
	position: sticky;
	top: 0;
	z-index: 5;
}
#header_height {
	height: 50px;
}
.setting_btn {
	border-top: 1px solid #707070;
	font-family: note-sans-jp-medium, Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB,
    Microsoft YaHei, SimSun, sans-serif;
	font-size: 0.9rem;
}
.back_clean_btn {
	background-color: transparent !important;
	min-width: 1rem;
	color: white;
	font-size: 0.9rem;
}
.v-list{
  background: #171921 !important;
	border: 1px solid #4A4A4A;
}
::v-deep{
	.v-text-field>.v-input__control>.v-input__slot:before {
		border-style: none;
	}
	.v-text-field>.v-input__control>.v-input__slot:after {
		border-style: none;
	}
	.v-text-field--outlined > .v-input__control > .v-input__slot {
		background: #272727;
	}
	.v-list-item__content{
		color: white;
	}
	.v-input__slot {
		padding-right: 2px !important;
	}
	.v-input__append-inner {
		margin-top: 16px !important;
		padding-left: 0px !important;
	}
	// Select Box Height 설정
	.v-text-field--outlined > .v-input__control > .v-input__slot {
		min-height: 35px !important;
	}
	.v-text-field--outlined.v-input--dense.v-text-field--outlined > .v-input__control {
		height: 35px;
	}
}
</style>